import * as React from 'react';
import cn from 'classnames';

import { useTheme } from '../../../theme';
import { format } from '../../../utils';
import { SegmentFragment } from '@websky/graphql';
import { useTranslation } from 'react-i18next';
import { cityIn } from 'lvovich';
import { getDurationString } from '../../../Results/utils';

export enum hintType {
	Warning = 'Warning',
	Info = 'Info',
	Promo = 'Promo',
	StopHint = 'StopHint'
}

interface Props {
	type: hintType;
	segment?: SegmentFragment;
	isVisible?: boolean;
	text?: string;
}

const FlightInfoCardHint: React.FC<Props> = ({ type, segment, text, isVisible }) => {
	const { FlightInfoCardHint: css } = useTheme('FlightInfoCard');
	const { t } = useTranslation(['FlightInfoCard', 'DesktopFlightInfo']);

	return (
		<div
			className={cn(css.wrapper, {
				[css.wrapper_info]: type === hintType.Info,
				[css.wrapper_warning]: type === hintType.Warning,
				[css.wrapper_promo]: type === hintType.Promo,
				[css.wrapper_stophint]: type === hintType.StopHint
			})}
		>
			{type === hintType.Warning &&
				t('Online checkin opens {{date}}', {
					date: format(segment.arrival.date, 'dd MMM yyyy')
				})}
			{type === hintType.StopHint && (
				<div className={cn(css.stopHint)}>
					<div>
						<span>
							{t('TechnicalLandingIn', {
								ns: 'DesktopFlightInfo',
								count: segment.stops.length
							})}
						</span>{' '}
						<span>
							{segment.stops
								.map(
									stop => `${cityIn(stop?.airport?.city?.name)} – ${getDurationString(stop.duration)}`
								)
								.join(', ')}
						</span>
					</div>
				</div>
			)}
			{type === hintType.Info && t('Time in route {{time}}', { time: text })}
		</div>
	);
};

export default FlightInfoCardHint;
